import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Fade } from 'react-reveal'

const VideoBanner = ({ video, mobileVideo, image, withinGrid, halfHeight }) => {

  const [videoSrc, setVideoSrc] = React.useState(mobileVideo || video)

  React.useEffect(() => {
    if (window.innerWidth > 900) {
      setVideoSrc(video || mobileVideo)
    }
  }, [])

  return (
    <section className={`video-banner ${withinGrid ? 'video-banner--grid' : ''} ${halfHeight ? 'video-banner--half' : ''}`}>
      <Fade bottom distance='40px'>
        <div className='video-banner__inner'>
          <video 
            src={ videoSrc } 
            poster={ image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src }
            autoPlay muted loop playsInline 
          />
        </div>
      </Fade>
    </section>
  )
}

export default VideoBanner